// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "items/tablefix"
import 'bootstrap/dist/css/bootstrap.min.css'

Rails.start()
ActiveStorage.start()

require('jquery');
require('@nathanvda/cocoon');
require('bootstrap');
require('pages/orders');
require('packs/search_reset');
require('packs/select2.js');